(function () {
  document.documentElement.classList.add('ar-launch-motion-ready');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initReveals = (root) => {
    const items = root.querySelectorAll('.ar-launch-reveal:not([data-ar-launch-ready])');
    if (!items.length) return;

    if (prefersReducedMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => {
        item.dataset.arLaunchReady = 'true';
        item.classList.add('is-inview');
      });
      return;
    }

    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        currentObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });

    items.forEach((item) => {
      item.dataset.arLaunchReady = 'true';
      observer.observe(item);
    });
  };

  const initColorPicker = (root) => {
    const buttons = root.querySelectorAll('[data-ar-color]');
    if (!buttons.length) return;

    buttons.forEach((button) => {
      const preload = new Image();
      preload.src = button.dataset.image;

      button.addEventListener('click', () => {
        if (button.classList.contains('is-active')) return;
        const imageUrl = button.dataset.image;
        const alt = button.dataset.alt || '';

        buttons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });

        root.querySelectorAll('[data-ar-color-name]').forEach((label) => {
          label.textContent = button.dataset.arColor;
        });

        root.querySelectorAll('[data-ar-color-image]').forEach((image) => {
          image.classList.add('is-changing');
          window.setTimeout(() => {
            image.src = imageUrl;
            image.alt = alt;
            image.classList.remove('is-changing');
          }, prefersReducedMotion.matches ? 0 : 180);
        });
      });
    });
  };

  const initParallax = (root) => {
    if (prefersReducedMotion.matches) return;
    const hero = root.querySelector('.ar-launch-hero');
    if (!hero) return;

    let ticking = false;
    const update = () => {
      const rect = hero.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, -rect.top / Math.max(rect.height, 1)));
      hero.style.setProperty('--ar-parallax', progress.toFixed(3));
      ticking = false;
    };
    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-ar-flagship]:not([data-ar-flagship-ready])').forEach((root) => {
      root.dataset.arFlagshipReady = 'true';
      initReveals(root);
      initColorPicker(root);
      initParallax(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
